import {
  GET_ITEMCODE_TO_UPC_REQUEST,
  GET_ITEMCODE_TO_UPC_SUCCESS,
  GET_ITEMCODE_TO_UPC_ERROR,
} from "../actions/types";

export const ItemCodeToupc = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ITEMCODE_TO_UPC_REQUEST:
      return {
        loading: true,
      };
    case GET_ITEMCODE_TO_UPC_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_ITEMCODE_TO_UPC_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
